import { Locale } from '@headless-workspace/config';
import { FormsByTypeRepository, Result } from '@headless-workspace/core-domain';
import {
    memoryCacheAuthStrategy,
    memoryCacheQueryParamStrategy,
    memoryCacheRefreshTokenStrategy,
} from '@headless-workspace/data';
import { RatingAndReviewsFormDTO } from './RatingsAndReviewsFormDTO';
import { mapRatingAndReviewsForm, RatingAndReviewsFormValue } from './RatingsAndReviewsFormValue';

export interface RatingsAndReviewsFormRepositorySpec {
    getRatingAndReviewsForm(locale: Locale, productId: string): Promise<Result<RatingAndReviewsFormValue>>;
}

export class RatingsAndReviewsFormRepository
    extends FormsByTypeRepository
    implements RatingsAndReviewsFormRepositorySpec
{
    REVIEW_FORM = 'review';

    constructor() {
        super(memoryCacheAuthStrategy, memoryCacheRefreshTokenStrategy, memoryCacheQueryParamStrategy);
    }

    async getRatingAndReviewsForm(locale: Locale, productId: string): Promise<Result<RatingAndReviewsFormValue>> {
        const params: Record<string, unknown> = {
            locale,
            productId,
        };
        return await this.getFormByType(this.REVIEW_FORM, params, (data) =>
            mapRatingAndReviewsForm(RatingAndReviewsFormDTO.parse(data)),
        );
    }
}
